import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { DeliveryScheduleCollectiveEditTemplate } from 'components/Templates'

const DeliveryScheduleCollectiveEdit: FC = () => {
  return (
    <Layout title={'お届け可能日を一括設定'}>
      <DeliveryScheduleCollectiveEditTemplate />
    </Layout>
  )
}

export default DeliveryScheduleCollectiveEdit
